<template>
  <div class="tool-panel">
    <h3><slot name="title"></slot></h3>
    <div class="tool-links">
      <ul>
        <slot></slot>
      </ul>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.tool-panel {
  & > h6 {
    font-weight: bold;
  }

  & > .tool-links {
    font-size: 0.75rem;
    
    & > ul {
      padding: 0;
      list-style: none;

      & > li {
          margin: 2px 0px;
      }
    }
  }
}
</style>
